export default "__VITE_ASSET__B5bR5ZX1__"